<template>
    <div class="flex flex-col gap-4 border-t border-gray-200 p-6">
        <div class="flex items-center justify-between">
            <h2 class="flex items-center gap-4 leading-6">
                <Icon :icon="IconDiscount" class="text-xl" />
                <span class="capitalize">
                    {{ $t('cart.loyaltyPoints') }}
                </span>
            </h2>
            <NuxtLink :to="localePath('/account')" class="font-bold uppercase text-primary">
                {{ $t('login') }}
            </NuxtLink>
        </div>
        <div class="flex items-center gap-4">
            {{ $t('cart.redeem') }}
            <FormKit
                type="number" name="loyaltyPoints" value="0" :classes="{
                    wrapper: 'w-16'
                }" />
            {{ $t('cart.loyaltyPoints') }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import IconDiscount from '@/assets/icons/discount.svg'
    import Icon from '~/components/Icon.vue'
    const localePath = useLocalePath()
</script>
